import script from "./SettingsChangelogFiltersBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsChangelogFiltersBar.vue?vue&type=script&setup=true&lang=js"

import "./SettingsChangelogFiltersBar.vue?vue&type=style&index=0&id=1d7892a7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d7892a7"]])

export default __exports__